module.exports = {
    language_title:'选择语言',
    language:'简体中文',
    company:'公司说明',
    address:'地址',
    service_tel:'服务电话',
    operator:'总机电话',
    complaint_tel:'投诉电话',
    email:'邮箱',
    submit:'提交',
    submiting:'提交中...',
    weTeamList:'核心团队',
    must_import:'请输入必填',
    scoll:'下拉',
    more:'更多',
    mores:'更多',
    name:'姓名',
    number:'客人数量',
    phone:'电话号码',
    event:'目的地',
    request:'您的需求',
    privacy:'隐私声明',
    explain:'Mandarin收集您的个人数据以处理您的请求并回复您。有关更多信息',
    country:'中国',
    project:'个项目',
    guests:'名嘉宾',
    submit_success:'提交成功',
    detail:'详情咨询',
    phones:'电话'
    
}



// WEBPACK FOOTER //
// ./src/i18n/zh_cn.js